import React, {Component} from 'react'
import FJIntroLabelInput from "./FJIntroLabelInput";
import FJIntroItem from './FJIntroItem'

import './FJIntros.less'

class FJIntros extends Component {

  constructor(props) {
    super(props);
    this.state = {
      hasExport: false,
    };
    this._exportBtnStyle = {marginTop: 0, minWidth: 272 + 'px'};
  }

  _handleIntroClick = (name) => {
    const {onIntroChange} = this.props;
    const {selectedIntroName} = this.props;
    if (name !== selectedIntroName && onIntroChange) {
      onIntroChange(name);
    }
  };

  _handleExportClick = () => {
    this.setState({
      hasExport: true,
    }, () => {
      const {videoName} = this.props;
      const {onExport} = this.props;
      if (videoName.trim() === '') {
        this.videoTitleInput.showErrorAnimation();
      } else {
        onExport();
      }
    });
  };

  render() {
    let {
      intros,
      style,
      selectedIntroName,
      videoNamePlaceholder,
      videoNameTitle,
      videoNameErrorText,
      videoName,
      userName,
      userNamePlaceholder,
      userNameTitle,
      introTitle,
      infoTitle,
      exportBtnText,
      inputPaddingLeft,
    } = this.props;
    let {
      onVideoNameChange,
      onVideoNameSubmit,
      onUserNameChange,
      onUserNameSubmit,
      onRenderPrimaryButton,
    } = this.props;
    let {hasExport} = this.state;
    let inputWidth = 460;

    return (
      <div className='c-export__intros' style={style}>
        <p className='c-export-option-title'>{infoTitle}</p>
        <FJIntroLabelInput inputPaddingLeft={inputPaddingLeft}
                           placeholder={videoNamePlaceholder}
                           errorValue={videoNameErrorText}
                           title={videoNameTitle}
                           value={videoName}
                           hasError={hasExport}
                           isRequired
                           ref={ele => this.videoTitleInput = ele}
                           inputWidth={inputWidth}
                           onChange={onVideoNameChange}
                           onSubmit={onVideoNameSubmit}
        />
        <FJIntroLabelInput inputPaddingLeft={inputPaddingLeft}
                           inputWidth={inputWidth}
                           value={userName}
                           placeholder={userNamePlaceholder}
                           title={userNameTitle}
                           onChange={onUserNameChange}
                           onSubmit={onUserNameSubmit}
        />
        <div className='c-export__intros-content'>
          <span className='c-export_intro-title c-export__intro-list-title'>{introTitle}</span>
          <div className='c-export__intro-list'>
            {
              intros.map((intro, index) => {
                const {thumbnail, url, name} = intro;
                return <FJIntroItem selected={selectedIntroName === name}
                                    thumbnail={thumbnail}
                                    url={url}
                                    style={{marginRight: (index + 1) % 3 === 0 ? 0 : 16}}
                                    id={name}
                                    key={name}
                                    onClick={this._handleIntroClick}/>
              })
            }
          </div>
          {
            onRenderPrimaryButton({
              className: 'c-export-btn',
              size: 'middle',
              style: this._exportBtnStyle,
              text: exportBtnText,
              onClick: this._handleExportClick,
            })
          }
        </div>
      </div>
    );
  }
}

export default FJIntros;
